// extracted by mini-css-extract-plugin
export default {"carousel":"carousel--Siv2w","anchor":"anchor--Siv2w","image":"image--Siv2w","grid":"grid--Siv2w","item":"item--Siv2w"};